export default __webpack_public_path__ + "static/media/about-01.a6154f2a.jpg";